<template>
  <div class="lmc__header">
    {{ trans('deal.state.' + code) }}
    <span class="lmc__counter pin">{{ number(counter) }}</span>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';
import { number } from '@elements/number-formatter';

export default {
  mixins: [ translationMixin ],

  props: {
    code: { type: String, default: '' },
    counter: { type: Number, default: 0 },
  },
  methods: {
    number,
  },
};
</script>
